import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext, ProfileContext } from '../App';
import { get } from '../util/HttpRequest'
import { formatDateTime } from '../util/Format';
import { Alert } from 'antd';

interface MaintenanceBannerSettings {
    fromDateUTC: string;
    toDateUTC: string;
}

function MaintenanceBanner() {
    const { isAuthenticated, extendSession } = useContext(AuthContext);
    const { languagePreference } = useContext(ProfileContext);
    const [setting, setSetting] = useState<MaintenanceBannerSettings | null>(null);
    const { t } = useTranslation('Layout');

    useEffect(() => {
        refreshData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [languagePreference]);

    function refreshData() {
        getData();
    };

    function getData() {
        if (isAuthenticated) {
            extendSession();
        }
        const url = new URL(import.meta.env.VITE_CCP_API_CCP + "/MaintenanceSchedule");
        console.log("Fetch maintenance schedule from " + url);
        get(url, "")
            .then((response) => {
                if (!response.ok) { throw response; }
                return response.json() as Promise<MaintenanceBannerSettings>;
            })
            .then((response) => {
                setSetting(response);
            })
            .catch((err) => {
                console.log("Error occuring while fetching maintenance schedule details: ", err.message);
            })
    }

    return (
        <>
            {setting && setting.fromDateUTC && setting.toDateUTC && (
                <div className='maintenance-banner'>
                    <Alert
                        type="warning"
                        banner
                        showIcon
                        title={
                            <span style={{ color: 'red' }}>
                                {t('maintenanceBanner', {
                                    dateTimeFrom: formatDateTime(setting.fromDateUTC),
                                    dateTimeTo: formatDateTime(setting.toDateUTC)
                                })}
                            </span>}
                    />
                </div>
            )}
        </>
    );
}
export default MaintenanceBanner;